// Phase 6 — Track B T-B6. Login form validation.
//
// Mirrors the backend's `loginSchema` (src/core/auth/routes.ts). Phase 6 web
// SPA only uses cookie mode (blueprint §7.4 / plan §2.5), so the optional
// `mode` and `device_label` fields are accepted in the type but the form
// never sets them.
//
// The schema is `.strict()` — rejecting unknown fields client-side prevents
// devtools-injected typo bugs from reaching the network. The backend would
// reject them anyway, but the round-trip is wasted.
//
// MIN_PASSWORD_LENGTH is 12 server-side. The login form does NOT enforce
// the minimum (because old accounts may have been created before the limit
// rose), only that the field is non-empty. Registration forms — when they
// land in Phase 7 — must use a separate `registerSchema` that enforces 12+.

import { z } from 'zod';

export const loginFormSchema = z
  .object({
    email: z.string().trim().toLowerCase().email().max(254),
    password: z.string().min(1).max(1024),
  })
  .strict();

export type LoginFormBody = z.infer<typeof loginFormSchema>;

/** What the backend's `loginSchema` actually accepts; web v1 only sends the first two. */
export const loginRequestSchema = z
  .object({
    email: z.string().email().max(254),
    password: z.string().min(1).max(1024),
    mode: z.enum(['cookie', 'token']).optional(),
    device_label: z.string().max(64).optional(),
  })
  .strict();

export type LoginRequestBody = z.infer<typeof loginRequestSchema>;
